/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Coinvestments_Tracking_Stage_Withvalue2Inputs */

const en_coinvestments_tracking_stage_withvalue2 = /** @type {(inputs: Coinvestments_Tracking_Stage_Withvalue2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stage: ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Stage: {label}" |
*
* @param {Coinvestments_Tracking_Stage_Withvalue2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_stage_withvalue2 = /** @type {((inputs: Coinvestments_Tracking_Stage_Withvalue2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Stage_Withvalue2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_stage_withvalue2(inputs)
});
export { coinvestments_tracking_stage_withvalue2 as "coInvestments_tracking_stage_withValue" }